import { contentAddress } from "../config";
import handleResponse from "./handleResponse";

const base_user_url = "/api/v1/content";

const full_base_path = contentAddress + base_user_url;

export const getVideos = () => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/video" , requestOptions)
    .then(response => handleResponse(response))
    .then(response => response.json())
    .catch(error => {
      console.log('error', error);
      return [];
    });
}